import Home from "@/views/Home";

export default [
  {
    path: "home",
    name: "Home",
    component: Home,
    meta: {
      title: "极客-服务中心",
      nav: {
        icon: "el-icon-s-home",
        title: "工作台"
      },
      breadcrumb: {
        title: "工作台",
        replace: false
      }
    }
  }
];
